/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React, { useState } from "react";
import styles from "./Filter.module.css";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import cx from "classnames";
import HelpOutline from "@material-ui/icons/HelpOutline";
import Tooltip from "./../../../Tooltip/Tooltip";
import { constant } from "./../../../shared/constants/constants";
import {
  updateJobTypeFilterValue,
  updateUserFilterValue,
} from "./../../../store/actions";
import { useDispatch, useSelector, batch, shallowEqual } from "react-redux";

const useStyles = makeStyles((theme) => ({
  formCtrl: {
    width: "200px",
  },
  iconCont: {
    color: "grey",
    marginLeft: "12px",
  },
}));

// Job type selection filter
const UserJobFilter = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.ui.isLoading, shallowEqual);
  const jobType = useSelector((state) => state.geoUtil.jobType, shallowEqual);

  // handle any changes happen in job type dropdown
  const handleChange = (event) => {
    if (event.target.value === jobType) return;
    batch(() => {
      dispatch(updateJobTypeFilterValue(event.target.value));
      dispatch(updateUserFilterValue({ userId: "", name: "" }));
    });
  };

  const classes = useStyles();

  return (
    <div className={cx(styles.FilterCont, styles.MT12, styles.JSTCtr)}>
      <FormControl className={classes.formCtrl}>
        <Select
          disableUnderline
          disabled={isLoading}
          displayEmpty
          value={jobType}
          onChange={handleChange}>
          <MenuItem value="">{constant.SHOW_ALL_JOBS}</MenuItem>
          <MenuItem value="technician_jobs">
            {constant.SHOW_TECHNICIAN_JOBS}
          </MenuItem>
          <MenuItem value="contractor_jobs">
            {constant.SHOW_CONTRACTOR_JOBS}
          </MenuItem>
          <MenuItem value="unassigned_jobs">
            {constant.SHOW_UNASSIGNED_JOBS}
          </MenuItem>
        </Select>
      </FormControl>
      <Tooltip
        className={classes.iconCont}
        title={constant.JOB_FILTER_DESC}
        arrow>
        <HelpOutline />
      </Tooltip>
    </div>
  );
};

export default React.memo(UserJobFilter);
